import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader";
import API from "../../utils/Axios.utils";
import CustomModel from "../../utils/CustomModel";
import JobDetailsDialog from "./JobDetailsDialog";
import { Notification } from "../../utils/Notification";

// Deep-link landing page: visiting /jobs/code/:jobCode (while logged in)
// fetches that one job by its human-readable job_code and opens the same
// "Job Description" dialog used inside the jobs table, without requiring
// the visitor to search for it themselves. Closing the dialog returns to
// the main jobs list.
const JobDescriptionByCode = () => {
  const { jobCode } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");

    API.get(`/api/job/code/${encodeURIComponent(jobCode)}`)
      .then((res) => {
        if (!cancelled) setDetails(res.data);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(
            err?.response?.data?.message || "Job not found for this job code."
          );
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [jobCode]);

  const handleClose = () => navigate("/jobs");

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 40 }}>
        <ScaleLoader color="#2777AA" />
      </div>
    );
  }

  if (error) {
    return (
      <Notification
        message={error}
        severity="error"
        open={true}
        onClose={handleClose}
      />
    );
  }

  return (
    <CustomModel handleDialog={handleClose} open={true} title="Job Description">
      <JobDetailsDialog details={details} />
    </CustomModel>
  );
};

export default JobDescriptionByCode;
